import React, { useState } from 'react';
import Table from 'cccisd-graphql-table';
import Loader from 'cccisd-loader';
import Modal from 'cccisd-modal';
import XmlViewer from './xmlViewer';
import tableQuery from './deployTable.graphql';
import style from './style.css';
import IconInfo from 'cccisd-icons/info2';
import IconCheck from 'cccisd-icons/checkmark2';
import IconSpinner from 'cccisd-icons/spinner3';
import IconCross from 'cccisd-icons/cross';
import IconNotif from 'cccisd-icons/notification';
// import { useQuery } from '@apollo/client';
import { fail } from 'assert';
import { result, size } from 'lodash';
// https://monitoring.3c.test:4443/graphql
const BuildsTable = props => {
    const [isLoading, setIsLoading] = useState(false);

    const columns = [
        { name: 'buildId', label: 'Build ID', sort: true, filter: true },
        { name: 'app', label: 'App', sort: true, filter: true },
        { name: 'tag', label: 'Tag', sort: true, filter: true },
        { name: 'builtAt', label: 'Built At', sort: true, filter: true },
        {
            name: 'testcasesFailed',
            label: 'Test Results',
            sort: true,
            filter: true,
            render: rowWrapper => {
                const status = rowWrapper.row.testingStatus;
                const testsuitesData = rowWrapper.row.testsuiteData;
                let numCases = 0;
                let numCasesPassed = 0;
                testsuitesData?.forEach(suite => {
                    numCases += suite.testcases_run;
                    numCasesPassed += suite.testcases_passed;
                });
                let numCasesFailed = numCases - numCasesPassed;
                switch (status) {
                    case 1:
                        return '';
                    case 2: {
                        let newFileArray = [];
                        if (testsuitesData) {
                            console.log('testsuitesData:', testsuitesData);
                            newFileArray = testsuitesData.map(suite => {
                                return {
                                    suiteName: suite.suite_name,
                                    didSuiteRun: suite.exited_gracefully,
                                };
                            });
                        }
                        let fileArray = [];
                        let resultContent = '';
                        if (numCasesFailed !== null && !isNaN(numCasesFailed)) {
                            if (numCasesFailed === 0) {
                                resultContent = (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.25rem',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        <div style={{ color: 'green' }}>
                                            <IconCheck />
                                        </div>
                                        All tests passed
                                    </div>
                                );
                            } else {
                                resultContent = (
                                    <Modal
                                        trigger={
                                            <button
                                                className={style.button + ' btn btn-info'}
                                                type="button"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.25rem',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                <span style={{ color: 'red', display: 'inline-flex' }}>
                                                    <IconCross />
                                                </span>
                                                {numCasesFailed} test{numCasesFailed > 1 ? 's' : ''} failed
                                            </button>
                                        }
                                        title={`Test Results for ${rowWrapper.row.app} ${rowWrapper.row.tag}`}
                                        headerStyle={{
                                            backgroundColor: '#007298',
                                            color: '#fff',
                                        }}
                                    >
                                        <div>
                                            <XmlViewer
                                                appHandle={rowWrapper.row.app}
                                                buildTag={rowWrapper.row.tag}
                                                fileArray={newFileArray}
                                            />
                                        </div>
                                    </Modal>
                                );
                            }
                        } else {
                            resultContent = '';
                        }
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    minWidth: 'fit-content',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {resultContent}
                            </div>
                        );
                    }
                    case 3:
                        return '';

                    case 0:
                    case null:
                    default:
                        return (
                            <div style={{ display: 'inline-flex' }}>
                                <div style={{ color: 'orange', marginRight: '0.5rem' }}>
                                    <IconNotif />
                                </div>
                                <span>No automated tests available</span>
                            </div>
                        );
                }
            },
        },
        {
            name: 'testSuitesStatus',
            label: 'Testsuites Status',
            sort: true,
            filter: true,
            render: rowWrapper => {
                const testsuiteData = rowWrapper.row.testsuiteData;
                let numtestSuites = 0;
                let numtestSuitesRun = 0;
                if (testsuiteData) {
                    numtestSuites = testsuiteData.length;
                    numtestSuitesRun = testsuiteData.filter(suite => suite.exited_gracefully === true).length;
                }
                if (testsuiteData === null) {
                    return '';
                }
                console.log('test status: ', rowWrapper.row.testingStatus);
                if (rowWrapper.row.testingStatus === 1) {
                    return (
                        <div>
                            <IconSpinner />
                            <span>Tests Currently Running</span>
                        </div>
                    );
                }

                const numSuitesFailed = numtestSuites - numtestSuitesRun;
                if (rowWrapper.row.testingStatus === 1) {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <IconSpinner />
                            <span>Tests running</span>
                        </div>
                    );
                }
                return `${numtestSuites} test suites run, ${numSuitesFailed} failed`;
            },
        },
        {
            name: 'testcasesRun',
            label: 'Testcases Run',
            sort: true,
            filter: true,
            render: rowWrapper => {
                const testsuitesData = rowWrapper.row.testsuiteData;
                let numCases = 0;
                let numCasesPassed = 0;
                testsuitesData?.forEach(suite => {
                    numCases += suite.testcases_run;
                    numCasesPassed += suite.testcases_passed;
                });
                return `${numCases} run, ${numCasesPassed} passed`;
            },
        },
        { name: 'lastDeployedAt', label: 'Last Deployed At', sort: true, filter: true },
    ];
    const forceUpdate = async () => {
        setIsLoading(true);
        setIsLoading(false);
    };

    return (
        <Loader loading={isLoading} removeChildren>
            {!isLoading && (
                <div>
                    <Table
                        query={tableQuery}
                        rowKey="buildId"
                        orderBy="buildId"
                        isAscentOrder={false}
                        columns={columns}
                    />
                </div>
            )}
        </Loader>
    );
};

export default BuildsTable;
